import { formatUsd } from "../../shared/money";
import type { PublicHolder } from "../../shared/types";

export function CurrentHolder({ holder }: { holder: PublicHolder | null }) {
  if (!holder) {
    return (
      <section className="holder-panel holder-empty" aria-labelledby="holder-title">
        <div className="holder-topline">
          <p className="placement-label">CURRENT HOLDER</p>
          <p className="holder-number">OPEN</p>
        </div>
        <div className="holder-copy">
          <h1 id="holder-title">Nobody has pressed it yet.</h1>
          <p className="holder-message">Let's keep it that way.</p>
        </div>
        <footer className="holder-meta">
          <p className="holder-empty-note">The first successful press becomes the holder.</p>
          <dl className="holder-facts">
            <div>
              <dt>PAID</dt>
              <dd>NOTHING YET</dd>
            </div>
            <div>
              <dt>STATUS</dt>
              <dd>UNCLAIMED</dd>
            </div>
          </dl>
        </footer>
      </section>
    );
  }

  const holdingSince = new Intl.DateTimeFormat("en", { dateStyle: "medium" }).format(
    holder.currentPeriodStartedAt,
  );

  return (
    <section className="holder-panel" aria-labelledby="holder-title">
      <div className="holder-topline">
        <p className="placement-label">CURRENT HOLDER</p>
        <p className="holder-number">PRESS #{holder.pressNumber}</p>
      </div>
      <div className="holder-copy">
        <h1 id="holder-title">{holder.displayName}</h1>
        <p className={`holder-message${holder.publicMessage ? "" : " holder-message-empty"}`}>
          {holder.publicMessage || "No public message."}
        </p>
      </div>
      <footer className="holder-meta">
        {holder.destinationHostname ? (
          <a
            href={`/go/${holder.pressNumber}`}
            target="_blank"
            rel="nofollow ugc sponsored noopener noreferrer"
          >
            VISIT {holder.destinationHostname.toUpperCase()}
          </a>
        ) : null}
        <dl className="holder-facts">
          <div>
            <dt>PAID</dt>
            <dd>{formatUsd(holder.amountSubtotalCents)}</dd>
          </div>
          <div>
            <dt>HOLDING SINCE</dt>
            <dd>{holdingSince}</dd>
          </div>
        </dl>
      </footer>
    </section>
  );
}
